<template>
<CRow>
<CDataTable
    class="col-12 px-0"
    border
    :items="Object.values(tickets)"
    :fields="$dataTableFieldsMaker(fields)"
    hover
    :pagination="{...pagination, change: fetchTickets}"
    addTableClasses="bg-white"
>
    <template #id="{item}">
        <td dir="ltr">
            {{ $moment(item.created_at).format('jYYYY0jMM0jDD') }}
        </td>
    </template>
    <template #subject="{item}">
        <td
            class="cursor-pointer text-primary"
            v-if="$policy('ticket', item).details"
            @click="$router.push({name: user.setup_status === UserSetupStatus.COMPLETE ? 'tickets.details' : 'setup.tickets.details', params: {id: item.id}})"
        >
            <FaIcon icon="eye" class="align-middle mfe-1" />
            {{ item.subject }}
        </td>
        <td v-else></td>
    </template>
    <template #category="{item}">
        <td v-if="$policy('ticket').execute">
            <CSelect
                :options="selectableCategories"
                @update:value="value => updateTicket(item, {category_id: value})"
                :value="item.category.id"
                addInputClasses="w-auto"
            />
        </td>
        <td v-else>
            {{ item.category.title }}
        </td>
    </template>

    <template #lastUpdate="{item}">
        <td dir="ltr">
            {{ $moment(item.updated_at).format('L') }}
        </td>
    </template>

    <template #status="{item}">
        <td v-if="$policy('ticket').execute">
            <CSelect
                :options="ticketStatusOption"
                @update:value="value => updateTicket(item, {status: value})"
                :value="item.status"
                :addInputClasses="statusInputClass(item.status)"
            />
        </td>
        <td v-else>
            <span :class="'badge badge-'+ticketStatusBadge(item)">{{ ticketStatusStr(item) }}</span>
        </td>
    </template>
    <template #createdBy="{item}">
        <td>
            {{ item.created_by.full_name }}
        </td>
    </template>
    <template #createdFor="{item}">
        <td>
            {{ item.created_for.full_name }}
        </td>
    </template>
    <template #responsible="{item}">
        <td v-if="$policy('ticket').select_responsible">
            <CSelect
                :options="selectableResponsiblesWithNullStart"
                @update:value="value => selectResponsible({id: item.id, responsible_id: value})"
                :value="item.responsible_id"
            />
        </td>
        <td v-else>
            {{ item.responsible.full_name || $t('ticket.not_defined') }}
        </td>
    </template>
</CDataTable>
</CRow>
</template>

<script>
import fields from './fields'
import { mapGetters, mapActions } from 'vuex'
import { ticketStatusOption } from '@/common/data'
import { ticketStatusBadge, ticketStatusStr, statusInputClass } from './methods'
import { UserSetupStatus } from '@/constants'

export default {
    name: 'Table',

    data() {
        return {
            fields,
            ticketStatusOption,
            UserSetupStatus,
        }
    },

    computed: {
        ...mapGetters({
            user: 'user/current',
            users: 'user/users',
            roles: 'role/roles',
            selectableCategories: 'category/selectableCategories',
            tickets: 'ticket/tickets',
            pagination: 'ticket/pagination',
            filterMeFields: 'filterMeComponent/filterMeFields'
        }),
        selectableResponsiblesWithNullStart() {
            const role_ids = Object.keys(this.roles)

            const selectableResponsibles =  Object.keys(this.users).map(id => {
                const user = this.users[id]

                return role_ids.includes(user.role_id)
                    ? { value: id, label: user.full_name }
                    : false
            }).filter(item => item !== false)

            return [
                {
                    value: '',
                    label: '',
                },
                ...selectableResponsibles
            ]
        }
    },

    methods: {
        ...mapActions({
            fetch: 'ticket/fetch',
            edit: 'ticket/edit',
            selectResponsible: 'ticket/selectResponsible',
        }),
        ticketStatusBadge,
        ticketStatusStr,
        statusInputClass,
        fetchTickets(activePage = 1) {
            this.fetch({
                page: activePage,
                ...this.filterMeFields,
            })
        },
        updateTicket(item, data) {
            const params = {
                id: item.id,
                status: data.status || item.status,
                category_id: data.category_id || item.category.id
            }
            this.edit(params)
                .then(() => {
                    item.status = params.status
                    item.category.id = params.category_id
                })
        },
    }
}
</script>